import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';

const LanguageSelector = () => {
  const { i18n } = useTranslation('nav');

  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const selectLanguage = (lang: string) => {
    i18n.changeLanguage(lang);
    setAnchorEl(null);
  };

  return (
    <>
      <Button
        aria-controls="simple-menu"
        aria-haspopup="true"
        itemID='language-selector'
        color="inherit"
        onClick={handleClick}
      >
        {i18n.language}
      </Button>
      <Menu
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        color="inherit"
      >
        <MenuItem onClick={() => selectLanguage('pt-BR')} value="pt-BR">
          PT-BR
        </MenuItem>
        <MenuItem onClick={() => selectLanguage('en')} value="en">
          EN-US
        </MenuItem>
      </Menu>
    </>
  );
};

export default LanguageSelector;
